/**
 * Aggiunte rispetto a Volto:
 * - Aggiunti ai link eventuali attributi custom
 */
import React from 'react';
import cx from 'classnames';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import config from '@plone/registry';
import {
  isInternalURL,
  flattenToAppURL,
  URLUtils,
} from '@plone/volto/helpers/Url/Url';
import Icon from '@redturtle/iovisit-theme/components/Icon/Icon';

const ViewLink = ({ url, target, download, children, ...attributes }) => {
  const { openExternalLinkInNewTab } = config.settings;
  return (
    <UniversalLink
      href={url}
      openLinkInNewTab={
        (openExternalLinkInNewTab && !isInternalURL(url)) || target === '_blank'
      }
      download={download}
      {...attributes}
    >
      {children}
    </UniversalLink>
  );
};

export const LinkElement = (props) => {
  const { attributes, children, element, mode = 'edit' } = props;
  const isInternalUrl = isInternalURL(element.data?.url);
  const linkUrl = element.data?.url;
  const checkedURL = URLUtils.checkAndNormalizeUrl(element.data.url);
  const isTelephoneOrMail = checkedURL.isMail || checkedURL.isTelephone;

  return mode === 'view' ? (
    <ViewLink
      {...(element.data || {})}
      className={cx(attributes.className, {
        'with-external-link-icon':
          !isInternalUrl && config.settings.markSpecialLinks,
      })}
      {...attributes}
    >
      {children}
    </ViewLink>
  ) : (
    <a
      {...attributes}
      className={cx('slate-editor-link', attributes.className, {
        external: !isInternalUrl,
        'with-external-link-icon':
          !isInternalUrl && config.settings.markSpecialLinks,
      })}
      href={isInternalUrl ? flattenToAppURL(linkUrl) : linkUrl}
      onClick={(e) => e.preventDefault()}
    >
      {Array.isArray(children)
        ? children.map((child, i) => {
            if (child?.props?.decorations) {
              const isSelection =
                child.props.decorations.findIndex((deco) => deco.isSelection) >
                -1;
              if (isSelection)
                return (
                  <span className="highlight-selection" key={`${i}-sel`}>
                    {child}
                  </span>
                );
            }
            return child;
          })
        : children}
      {!isInternalUrl &&
        config.settings.markSpecialLinks &&
        !isTelephoneOrMail && (
          <Icon
            prefix="fas"
            icon="external-link-alt"
            size="xs"
            className="external-link-icon"
          />
        )}
    </a>
  );
};
